export interface NameCheckPayloadModel {
  exist: boolean;
}
